import React from "react";

import "./../styles/components/WhatCard.css";

type WhatCardFields = {
  icon: string;
  title: string;
  content: string[];
  button: string;
  buttonLink: string;
};

const WhatCard: React.FC<WhatCardFields> = ({
  icon,
  title,
  content,
  button,
  buttonLink,
}) => {
  return (
    
    <div className="consultationCard">
      <div className="iconWrapper">
        <div className="iconCircle">
          <img  alt='icons' className="iconImage" src={icon} />
        </div>
      </div>

      <div className="cardContent">
        <h2 className="cardTitle">{title.toUpperCase()}</h2>
        <ul className="cardList">
          {content.map((val) => (
            <li> {val} </li>
          ))}
        </ul>
        <p className="cardFooter">
          <a href={buttonLink} target="_blank" rel="noreferrer"> <strong> {button} </strong> </a>
        </p>
      </div>
    </div>
  );
};

export default WhatCard;
